import {
  DatabasesAction,
  databasesActionCreators,
  databasesStardogRequestDispatchers,
} from 'src/common/actions/databases/databasesActionCreators';
import {
  StudioStateGetter,
  StudioThunkDispatch,
} from 'src/common/actions/StudioAction';

export const requestAvailableOptions =
  () =>
  (
    dispatch: StudioThunkDispatch<DatabasesAction>,
    getState: StudioStateGetter
  ) => {
    const { features } = getState();
    const {
      isAvailableDatabaseOptionsMethodSupported,
      isOverrideGraphQlDefaultLimitSupported,
    } = features.stardog;
    if (isAvailableDatabaseOptionsMethodSupported) {
      // For Stardog 7.7.2, the server returns an invalid defaultValue for
      // graphql.default.limit (see PLAT-2929). Studio must override this value,
      // or no other DB properties can be updated by the user unless they first
      // change the value of graphql.default.limit themselves.
      return databasesStardogRequestDispatchers.requestAvailableOptions(
        isOverrideGraphQlDefaultLimitSupported
      );
    }
    return dispatch(databasesActionCreators.setStaticAvailableOptions());
  };
